import { Record } from "immutable";
import moment from "moment";

const defaults = {
    brand_id: undefined,
    complete: undefined,
    created_on: undefined,
    file_type: undefined,
    files: [],
    format: undefined,
    id: undefined,
    last_id: undefined,
    last_value: undefined,
    modified_on: undefined,
    options: {},
    owner_account_id: undefined,
    processing: undefined,
    started: undefined,
};

export class FileExport extends Record(defaults) {
    declare brand_id: string;
    declare complete: boolean;
    declare created_on: moment.Moment;
    declare file_type: "xlsx" | "csv";
    declare files: any[];
    declare format: string;
    declare id: string;
    declare last_id?: string;
    declare last_value?: string;
    declare modified_on: moment.Moment;
    declare options: any;
    declare owner_account_id: string;
    declare processing: boolean;
    declare started: boolean;

    constructor(args) {
        super({
            ...args,
            created_on: moment.utc(args.created_on),
            modified_on: moment.utc(args.modified_on),
        });
    }
}
